function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M108.175 89.152v22.898c0 7.03-5.75 12.781-12.78 12.781H20.31c-7.029 0-12.78-5.75-12.78-12.781V36.966c0-7.03 5.751-12.78 12.78-12.78h24.497m3.081 60.286l73.923-73.924",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 15
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M123.919 59.306l.82-51.687-51.685.823",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 15,
  strokeLinejoin: "miter"
});

function SvgExternal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 133 133",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTMzIDEzMyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiPgogIDxwYXRoIGQ9Ik0xMDguMTc1IDg5LjE1MnYyMi44OThjMCA3LjAzLTUuNzUgMTIuNzgxLTEyLjc4IDEyLjc4MUgyMC4zMWMtNy4wMjkgMC0xMi43OC01Ljc1LTEyLjc4LTEyLjc4MVYzNi45NjZjMC03LjAzIDUuNzUxLTEyLjc4IDEyLjc4LTEyLjc4aDI0LjQ5N000Ny44ODggODQuNDcybDczLjkyMy03My45MjQiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjE1Ii8+CiAgPHBhdGggZD0iTTEyMy45MTkgNTkuMzA2bC44Mi01MS42ODctNTEuNjg1LjgyMyIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMTUiIHN0cm9rZS1saW5lam9pbj0ibWl0ZXIiLz4KPC9zdmc+";
export { SvgExternal as ReactComponent };